import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconAddOutline: TIconComponent = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g fill="none" fillRule="evenodd">
            <rect width="40" height="40" rx="20" fill="#333" />
            <path
                d="m20 10c0.55228 0 1 0.44772 1 1l-1e-3 7h8.001c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1h-8.001l1e-3 9c0 0.55228-0.44772 1-1 1s-1-0.44772-1-1l-1e-3 -9h-7.999c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1h7.999l1e-3 -7c0-0.55228 0.44772-1 1-1z"
                fill="#fff"
            />
        </g>
    </Icon>
);
